import {
  actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { 
  jsonApiHeader, 
  showWarningMessage, 
  showErrorMessage, 
  actionCreator, 
  checkHttpStatus, 
  create_post_data, 
  createSearchUrl, 
  showSuccessMessage 
};

export const POST_BEHAVIOR_API = `${API_URL}/api/PatientBehaviorsReduction/SavePatientBehaviorsReduction`;
export const GET_BEHAVIOR_LIST_API = `${API_URL}/api/PatientBehaviorsReduction/GetPatientBehaviorsReduction`;
export const GET_BEHAVIOR_DETAIL_API = `${API_URL}/api/PatientBehaviorsReduction/GetPatientBehaviorsReductionById`;
export const DELETE_BEHAVIOR_API = `${API_URL}/api/PatientBehaviorsReduction/DeletePatientBehaviorsReduction`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_BEHAVIOR_COLLECT_DATA_LIST_API = `${API_URL}/api/CollectData/GetPatientBehaviorCollectDataByBehaviorReductionId`;
export const DELETE_BEHAVIOR_COLLECT_DATA_API = `${API_URL}/api/CollectData/DeletePatientRecordABCDataByRecordDataId`;

export const GET_BEHAVIOUR_REDUCTION_SINGLE_GRAPH_API = `${API_URL}/api/PatientBehaviorsReduction/GetPatientBehaviorsReductionSingleGraph`
export const UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_STATUS_API = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateCollectedDTTData`;
export const UPDATE_BEHAVIOR_COLLECT_DATA_API = `${API_URL}/api/CollectData/UpdateCollectedBehaviorData`;
export const POST_RAWBEHAVIORDATA_API = `${API_URL}/api/CollectData/SaveRawBehaviorData`;
export const POST_BEHAVIOR_FROMCOLLECTDATA_API = `${API_URL}/api/PatientBehaviorsReduction/SavePatientBehaviorsReductionFromCollectData`;
export const POST_COPYPATIENTBEHAVIORREDUCTION_API = `${API_URL}/api/PatientBehaviorsReduction/CopyPatientBehaviorReductionBehavior`;

export const behaviorActionTypes = {
  get_masterData: createRequestActionTypes('GET_MASTERDATA'),
  save_behavior: createRequestActionTypes('SAVE_BEHAVIOR'),
  get_behaviorList: createRequestActionTypes('GET_BEHAVIORLIST'),
  get_behaviorDetail: createRequestActionTypes('GET_BEHAVIORDETAIL'),
  delete_behavior: createRequestActionTypes('DELETE_BEHAVIOR'),
  get_behaviorCollactDataListByBehaviorId: createRequestActionTypes('GET_BEHAVIOR_COLLECT_DATA_LIST'),
  delete_behaviorCollactData: createRequestActionTypes('DELETE_BEHAVIOR_COLLECT_DATA'),
  get_behaviourReductionSingleGraph: createRequestActionTypes('GET_BEHAVIOUR_REDUCTION_SINGLE_GRAPH'),
  update_collectedBehaviorDataStatus: createRequestActionTypes('UPDATE_BEHAVIOR_COLLECT_DATA'), 
  save_rawbehaviordata: createRequestActionTypes('SAVE_RAWBEHAVIORDATA'),
  save_copyPatientBehaviorReduction: createRequestActionTypes('SAVE_COPYPATIENTBEHAVIORREDUCTION'),
};

export const MODULE = 'DCMASTER_BEHAVIORSREDUCTION';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Behavior/constants/ApiConstants.js